import { Button, Menu } from "@mantine/core";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import AuthorizationModal from "src/generator/_Modals/AuthorizationModal/AuthorizationModal";
import { useV2Save } from "src/generatorV2/hooks/useV2Save";
import { useCanEditEntry } from "src/generator/hooks/useCanEditEntry";
import { useSaveEntry } from "src/generator/hooks/useSaveEntry";
import { useSelector } from "src/redux/hooks";
import { Notification } from "src/utils/Notification";
import { crumb } from "src/utils";

interface Props {
  hamburger?: boolean;
}

const SaveEntryButton = ({ hamburger }: Props) => {
  const {
    saveEntry: saveEntryV1,
    loading,
    opened,
    open,
    close,
    disabled,
    usersSelect,
  } = useSaveEntry();
  const { saveEntry: saveEntryV2, isSaving: isV2Saving } = useV2Save();
  const isV2 = useSelector(
    state => state.generatorSlice.lbentry.generator === "v2",
  );
  const canEditEntry = useCanEditEntry();

  const { trigger } = useFormContext();
  const handleOpen = useCallback(async () => {
    // // Log save entry button click
    // crumb("Save Entry Button: Clicked", {
    //   component: "LogBar/SaveEntryButton",
    //   disabled,
    //   canEditEntry,
    // });

    // const valid = await trigger();
    // if (!valid) {
    //   crumb("Save Entry Button: Validation failed", {
    //     reason: "Required fields missing",
    //   });
    //   Notification("Error", "You need to fill all required fields", "red");
    //   return;
    // }
    try {
      open();
    } catch (error: any) {
      crumb("Save Entry Button: Open modal failed", {
        error: error?.message ?? "Unknown error",
      });
      Notification("Error", error?.message ?? "Something went wrong", "red");
      console.error(error);
    }
  }, [trigger, open, disabled, canEditEntry]);

  const Component = useCallback(
    () =>
      hamburger ? (
        <Menu.Item
          onClick={handleOpen}
          leftSection={<IconDeviceFloppy size={20} />}
          disabled={disabled}>
          Save
        </Menu.Item>
      ) : (
        <Button
          onClick={handleOpen}
          leftSection={<IconDeviceFloppy size={"1rem"} />}
          ml={15}
          disabled={disabled}>
          Save
        </Button>
      ),
    [hamburger, handleOpen, disabled],
  );

  if (!canEditEntry) {
    return null;
  }

  return (
    <>
      <Component />
      <AuthorizationModal
        opened={opened}
        close={close}
        onSubmit={isV2 ? saveEntryV2 : saveEntryV1}
        loading={isV2 ? isV2Saving : loading}
        users={usersSelect ?? []}
        isEntry={true}
      />
    </>
  );
};

export default SaveEntryButton;
